import { ReportProfileAlertResourceBaseModel } from '../../../profile/report-profile-alert-resource-base-model';
import { SharePointReportProfilePermissions } from '../../../microsoft/sharepoint/profile/share-point-report-profile-permissions';

export class SharePointReportProfileAlertPermissionsModel extends ReportProfileAlertResourceBaseModel {
  permissions: SharePointReportProfilePermissions;
  allPaths: boolean;
  invalidPaths: string[];
}
